import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';

import { LuicModule } from '@lohmann-birkner/luic';
import { TranslateModule } from '@ngx-translate/core';

import { NavigationButtonsComponent } from './buttons/navigation-buttons.component';
import { HistoryNavigationComponent } from './history/history-navigation.component';
import { LogoComponent } from './logo/logo.component';
import { NavigationButton } from './models/navigation-button.model';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  standalone: true,
  imports: [
    LogoComponent,
    CommonModule,
    LuicModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatListModule,
    MatSelectModule,
    MatSidenavModule,
    MatToolbarModule,
    RouterModule,
    TranslateModule,
    NavigationButtonsComponent,
    HistoryNavigationComponent,
  ],
})
export class AppNavbarComponent {
  @Output() navigate = new EventEmitter<string>();
  @Input() HandsetPortrait: boolean = false;
  @Input() currentHandyOrientation: string = '';

  public buttons: NavigationButton[] = [
    {
      label: 'COMPONENT.SIDEBAR.start',
      link: '/start',
      activeOnRoutes: ['/start'],
      handyLabel: 'home',
      abbreviation: 'Home',
    },
    {
      label: 'COMPONENT.SIDEBAR.orga',
      link: '/organization',
      activeOnRoutes: ['/organization', '/patient-details'],
      handyLabel: 'medical_services',
      abbreviation: 'Orga',
    },
    {
      label: 'COMPONENT.SIDEBAR.workflow',
      link: '/workflow',
      activeOnRoutes: ['/workflow'],
      abbreviation: 'Workflow',
      handyLabel: 'account_tree',
    },
  ];
  constructor(public router: Router) {}

  public onNavigate(link: string): void {
    this.navigate.emit(link);
  }
}
